export default __webpack_public_path__ + "static/media/calendar-grey.76ece01f.svg";